import { useEffect } from 'react';
import { reduceMotionForMobile, isMobile } from '@/utils/performanceOptimization';

export const MobileLoadingOptimizer = () => {
  useEffect(() => {
    // Apply mobile-specific optimizations on mount
    if (isMobile()) {
      // Reduce animations for better performance
      reduceMotionForMobile();
      
      // Disable some browser features that can slow down mobile
      document.documentElement.style.setProperty('--scroll-behavior', 'auto');
      
      // Optimize viewport for mobile - ensure consistent settings
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, minimum-scale=1.0, viewport-fit=cover, interactive-widget=resizes-visual');
      }
      
      // Preload critical resources
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = '/placeholder.svg';
      link.as = 'image';
      document.head.appendChild(link);
    }
  }, []);

  return null; // This component doesn't render anything
};